import { MailOutlined } from "@ant-design/icons";
import { Alert, Button, Col, Form, Input, Row } from "antd";
import DocumentTitle from "react-document-title";
import { remindPassword } from "../../data/firebase/auth";
import { useState } from "react";
import {
  analyticsLogEvent,
  analyticsReportError,
} from "../../data/firebase/analytics";

interface RemindPasswordModel {
  email: string;
}

interface ErrorType {
  code: keyof typeof errorCodes;
}

const errorCodes = {
  "auth/invalid-email": "Invalid email",
  "auth/user-not-found": "Invalid email",
  "auth/too-many-requests": "Too many login attempts",
  "auth/missing-continue-uri": "Internal error",
  "auth/invalid-continue-uri": "Internal error (2)",
  "auth/unauthorized-continue-uri": "Internal error (3)",
};

export default function RemindPassword() {
  const [formError, setFormError] = useState<string | undefined>(undefined);
  const [successMessage, setSuccessMessage] = useState<string | undefined>(
    undefined,
  );

  const onFinish = async ({ email }: RemindPasswordModel) => {
    try {
      await remindPassword(email);
      setSuccessMessage("Done! Go check your email!");
      analyticsLogEvent("password_changed");
    } catch (error) {
      const errorCode: keyof typeof errorCodes = (error as ErrorType).code;
      setFormError(
        (error as ErrorType).code in errorCodes
          ? errorCodes[errorCode]
          : "Unknown error",
      );
      analyticsReportError(error as Error);
    }
  };

  return (
    <DocumentTitle title="Wishlist - welcome">
      <Row justify={"center"}>
        <Col>
          <h1>Remind password</h1>
          {successMessage ? (
            <Alert type="success" message={successMessage} />
          ) : (
            <RemindPasswordForm onFinish={onFinish} formError={formError} />
          )}
        </Col>
      </Row>
    </DocumentTitle>
  );
}

interface RemindPasswordFormProps {
  onFinish: (data: RemindPasswordModel) => void;
  formError: string | undefined;
}

function RemindPasswordForm({ onFinish, formError }: RemindPasswordFormProps) {
  return (
    <Form
      name="normal_login"
      className="login-form"
      initialValues={{ remember: true }}
      onFinish={onFinish}
      style={{ maxWidth: 500 }}
    >
      {formError !== undefined && (
        <Alert
          message={formError}
          type="error"
          showIcon
          style={{ marginBottom: "20px" }}
        />
      )}
      <Form.Item
        name="email"
        rules={[
          { type: "email", message: "Please input a valid email" },
          { required: true, message: "Please input your email!" },
        ]}
      >
        <Input prefix={<MailOutlined />} placeholder="Email" />
      </Form.Item>

      <Form.Item>
        <Button type="primary" htmlType="submit">
          Send password reset email
        </Button>
      </Form.Item>
    </Form>
  );
}
